module.exports = __webpack_public_path__ + "img/google.f564fc3b.png";